import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/dist/v-phone-input.css'
import { createVPhoneInput } from 'v-phone-input'
import type { App } from 'vue'
// eslint-disable-next-line no-restricted-imports
import { VAutocomplete } from 'vuetify/components'

const locale = useCookie('language').value ?? 'en'
let country = 'GB'

if (locale === 'ru')
  country = 'RU'

if (locale === 'fr')
  country = 'FR'

if (locale === 'it')
  country = 'IT'

if (locale === 'de')
  country = 'DE'

const vPhoneInput = createVPhoneInput({
  countryIconMode: 'svg',
  defaultCountry: country,
  enableSearchingCountry: true,
})

export default function (app: App) {
  app.component('VAutocomplete', VAutocomplete)
  app.use(vPhoneInput)
}
